export default __webpack_public_path__ + "static/nature_trust.575053c35663234f41318a868a059aac.jpg";